

let wishlistAutoAddTimer = null;

let apiCalledForResultsSeen = false;
let apiCalledForCustomSlider = false;
let currentProId, collectionData, productItemData;
let customerId = "";
if (typeof __st.cid != "undefined") {
	customerId = __st.cid;
}
if (customerId != "" && !sessionStorage.getItem("wishlistLoaded_product")) {
	wishlist_product_list();
	getCollectionData(true)
	sessionStorage.setItem("wishlistLoaded_product", "true");
} else {
	checkVisibilityAndCallAPI();
	// checkCollectionAvailable();
}
// Initial check in case elements are in view on page load

var wishlistCheckURL = window.location.href;
var count_url = wishlistCheckURL.split("/").length;
if (wishlistCheckURL.includes("wishlist")) {
	if (count_url == 6) {
		share_wishlist_data();
	} else {
		getCollectionData(true)
		wishlist_product_list()
	}
}
var collectionId, collectionName;

async function createCollection(data) {
	try {

		const response = await $.ajax({
			url: `${window.apiUrl}/wishlist/collection`,
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			data: JSON.stringify(data),
		});
		return response.success ? response : response.status;
	} catch {
		return null;
	}
}
async function addProductToCollection(data) {
	try {
		// Make the AJAX POST request
		const response = await $.ajax({
			url: `${window.apiUrl}/wishlist/collection-item`,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			data: JSON.stringify(data),
		});



		// Retrieve existing local storage data
		let localProductData = localStorage.getItem("local_wish_prod_data");
		localProductData = localProductData ? JSON.parse(localProductData) : [];

		// Add the new variantId only if it's not already present
		if (!localProductData.includes(data.variantId)) {
			localProductData.push(data.variantId);
			localStorage.setItem("local_wish_prod_data", JSON.stringify(localProductData));
		}
        sessionStorage.setItem("wishlistFetched", "false");
		// Return success response
		return [response.success, data.groupId];
	} catch (error) {
		console.error("Error adding product to collection:", error);
		return [false, null];
	}
}
function toggleButtonState(inputSelector, buttonSelector) {
	const textValue = $(inputSelector).val().trim();
	$(buttonSelector).attr("disabled", !textValue);
}

// Initial empty-state log on page load
document.addEventListener("DOMContentLoaded", () => {
	syncWishlistEmptyState();
});

// Centralized empty-state toggle
function syncWishlistEmptyState() {
	try {
		const domCollections = $(".rb_wishlist_collection_list .ct_collection_box").length > 0;
		const domProducts = $(".rb_wishlist_all_product_list .ct_collection_product_box_item").length > 0;
		const rawLocal = localStorage.getItem("local_wish_prod_data");
		let hasLocalProducts = false;
		if (rawLocal) {
			const parsed = JSON.parse(rawLocal);
			hasLocalProducts = Array.isArray(parsed) && parsed.some(Boolean);
		}

		const isEmpty = !domCollections && !domProducts && !hasLocalProducts;

		if (isEmpty || $("body").hasClass("rb_wishlist_empty") ) {
			$("body").addClass("rb_wishlist_empty");
			$(".rb_empty_wishlist").show();
			$(".rb_wishlist_main").hide();
			$(".wishlist_recent_pro").show();
		} else {
			$("body").removeClass("rb_wishlist_empty");
			$(".rb_empty_wishlist").hide();
			$(".rb_wishlist_main").show();
		}
	} catch (e) {
		console.error("Wishlist empty state sync failed", e);
	}
}
function check_wishlist_added(variantId) {

	jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`).addClass(
		"active"
	);
}

function getLocalWishlistVariantIds() {
	try {
		const raw = localStorage.getItem("local_wish_prod_data");
		if (!raw) return [];
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed.map(String) : [];
	} catch (e) {
		return [];
	}
}

function syncPdpWishlistVariantState(variantId) {
	if (!variantId) return;
	const normalizedVariantId = String(variantId);
	const $pdpWishlistIcons = jQuery(
		'.template-product .ct_wishlist_product .wishlist_img_main, .template-product .sticky-content-container .wishlist_img_main'
	);
	if (!$pdpWishlistIcons.length) return;

	$pdpWishlistIcons.each(function () {
		jQuery(this).attr('data-prod-variant-id', normalizedVariantId);
	});

	const localIds = getLocalWishlistVariantIds();
	const isWishlisted = localIds.includes(normalizedVariantId);
	$pdpWishlistIcons.toggleClass('active', isWishlisted);
}

window.syncPdpWishlistVariantState = syncPdpWishlistVariantState;

function getCurrentPdpSelectedVariantId() {
	const $selector = jQuery('.template-product .product-form .original-selector, .template-product .original-selector').first();
	if (!$selector.length) return '';
	const value = $selector.val();
	return value ? String(value) : '';
}

jQuery(document).on('change', '.template-product .original-selector, .template-product .ct_varient_get', function () {
	const selectedVariantId = jQuery(this).val() || getCurrentPdpSelectedVariantId();
	syncPdpWishlistVariantState(selectedVariantId);
});

jQuery(document).on('variantChanged', '.template-product .product-form', function (_event, selectedVariant) {
	const variantId = selectedVariant && selectedVariant.id ? String(selectedVariant.id) : getCurrentPdpSelectedVariantId();
	syncPdpWishlistVariantState(variantId);
});
function uncheck_wishlist_added(variantId) {
	jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`).removeClass(
		"active"
	);
	jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`)
		.closest(".ct_hart_icon_main")
		.find(".rb_wish_remove")
		.show();
	setTimeout(() => {
		jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`)
			.closest(".ct_hart_icon_main")
			.find(".rb_wish_remove")
			.hide();
	}, 2000);
}
function isInView(element) {
	const elementTop = $(element).offset().top;
	const elementBottom = elementTop + $(element).outerHeight();
	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
}
function checkVisibilityAndCallAPI() {
	var wishLocalData = localStorage.getItem("local_wish_prod_data");

	if (wishLocalData != null ) { // This checks both for null and empty string
      jQuery(".wishlist_img_main").removeClass("active");
		if (wishLocalData != "") {

			var get_wish_local_data = JSON.parse(wishLocalData);
			if (Array.isArray(get_wish_local_data) && get_wish_local_data.length > 0) {
				jQuery.each(get_wish_local_data, function (index, element) {
					check_wishlist_added(element);
				});
				$(".rb_wishlist_count").addClass("rb_active_wish");
			} else { 
				$(".rb_wishlist_count").removeClass("rb_active_wish");
			}
		}else{
          //wishlist_product_list();
        }

	} else {
		//wishlist_product_list();
	}


}
function wishlist_product_list() {

	$.ajax({
		url: `${window.apiUrl}/customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}`,
		method: "GET",
		headers: {
			"Content-Type": "application/json"
		},
	}).done(async function (response) {
		if (response.length > 0) {
			localStorage.setItem("local_wish_prod_data", JSON.stringify(response));
			jQuery.each(response, function (index, element) {

				check_wishlist_added(element);
			});
			var product_count = response.length;
			$(".wishlist_product_tab_count").text(`(${product_count})`);
			$(".rb_wishlist_count").addClass("rb_active_wish");
		} else {
			localStorage.setItem("local_wish_prod_data", [""]);
			jQuery(`.wishlist_img_main`).removeClass(
				"active"
			);
			$(".rb_wishlist_count").removeClass("rb_active_wish");

			//jQuery(`.rb_wishlist_count`).text(0);
		}
	});
}
async function fetchCollectionList(uniqueId, customerId) {
	try {
		const response = await $.ajax({
			url: `${window.apiUrl}/wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}`,
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});
		return response || [];
	} catch (error) {
		console.error("Error fetching collection list:", error);
		return [];
	}
}
function updateWishlistUI(addedId, $parent) {
	$(".wishlist_popup_main").removeClass("active");
	$(`.wishlist_img_main[data-prod-id="${addedId}"]`).addClass("active");
	$parent.closest(".ct_hart_icon_main").find(".wish_added").show();
	setTimeout(() => {
		$parent.closest(".ct_hart_icon_main").find(".wish_added").hide();
	}, 2000);
	const count = parseInt($(".rb_wishlist_count").text(), 10) + 1;
	$(".rb_wishlist_count").text(count).addClass("rb_active_wish");
}
function updateLocalWishlist(varId) {
	let localProdData = localStorage.getItem("local_wish_prod_data");
	localProdData = localProdData ? JSON.parse(localProdData) : [];
	if (!localProdData.includes(varId)) {
		localProdData.push(varId);
		localStorage.setItem("local_wish_prod_data", JSON.stringify(localProdData));
	}
}
function showCollectionPopup(collectionList) {
  const collections = (collectionList || [])
    .filter(el => Array.isArray(el.items) && el.items.length > 0)
    .map(el => {
      const thumb = el.items[0]; // ← first image only
      return `
        <label class="wishlist_collec_box">
          <div class="wishlist_collec_img">
            <div class="wishlist_collec_img_box_wrap">
              <img src="${thumb}" loading="lazy" alt="${el.name}">
            </div>
            <input type="radio" name="collection_id"
                   data-collection-id="${el.id}"
                   data-collection-name="${el.name}">
            <div class="wishlist_checkbox"></div>
          </div>
          <div class="wishlist_collec_text">
            <div class="wishlist_collec_title">${el.name}</div>
            <div class="wishlist_collec_subtitle">${el.totalItem} ${el.totalItem === 1 ? 'Item' : 'Items'}</div>
          </div>
        </label>`;
    });

  $(".wishlist_collec_inner").html(collections.join(""));
  $(".rdx_create_collection_btn").show();
  $(".create_collection_btn_secend").hide();
  $(".current_input_row").removeClass("rb_wishlist_hidden");
  $(".wishlist_collec_list").show();
  $(".wishlist_popup_main").addClass("active");
}

function showCollectionPopup(collectionList) {
  renderAddedStrip();  
  const rows = (collectionList || [])
    .filter(el => Array.isArray(el.items) && el.items.length > 0)
    .map(el => {
      const thumb = el.items[0];
      const countText = `${el.totalItem} ${el.totalItem === 1 ? 'Item' : 'Items'}`;
      return `
        <label class="wishlist_collec_box">
          <div class="wishlist_collec_img">
            <div class="wishlist_collec_img_box_wrap">
              <img src="${thumb}" loading="lazy" alt="${el.name}">
            </div>
            <input type="radio" name="collection_id"
                   data-collection-id="${el.id}"
                   data-collection-name="${el.name}">
            <div class="wishlist_checkbox"></div>
          </div>

          <div class="wishlist_collec_text">
            <div class="wishlist_collec_title">${el.name}</div>
            <div class="wishlist_collec_subtitle" data-count="${countText}">${countText}</div>
          </div>

          <!-- right-side icons -->
          <span class="wish-row-icon wish-row-icon--plus" aria-hidden="true">
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.5 17.5C3.8 17.5 0 13.7 0 9C0 4.3 3.8 0.5 8.5 0.5C13.2 0.5 17 4.3 17 9C17 13.7 13.2 17.5 8.5 17.5ZM8.5 1.5C4.35 1.5 1 4.85 1 9C1 13.15 4.35 16.5 8.5 16.5C12.65 16.5 16 13.15 16 9C16 4.85 12.65 1.5 8.5 1.5Z" fill="#454545"/>
              <path d="M4 9C4 8.72386 4.22386 8.5 4.5 8.5H12.5C12.7761 8.5 13 8.72386 13 9C13 9.27614 12.7761 9.5 12.5 9.5H4.5C4.22386 9.5 4 9.27614 4 9Z" fill="#454545"/>
              <path d="M8 5C8 4.72386 8.22386 4.5 8.5 4.5C8.77614 4.5 9 4.72386 9 5V13C9 13.2761 8.77614 13.5 8.5 13.5C8.22386 13.5 8 13.2761 8 13V5Z" fill="#454545"/>
            </svg>
          </span>
          <span class="wish-row-icon wish-row-icon--check" aria-hidden="true">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8.70458" cy="8.69872" r="6.21239" fill="white"/>
<path d="M8.5 0C10.7543 0 12.9163 0.895533 14.5104 2.48959C16.1045 4.08365 17 6.24566 17 8.5C17 10.7543 16.1045 12.9163 14.5104 14.5104C12.9163 16.1045 10.7543 17 8.5 17C6.24566 17 4.08365 16.1045 2.48959 14.5104C0.895533 12.9163 0 10.7543 0 8.5C0 6.24566 0.895533 4.08365 2.48959 2.48959C4.08365 0.895533 6.24566 0 8.5 0ZM7.44114 10.1769L5.55293 8.2875C5.48524 8.21981 5.40487 8.16611 5.31643 8.12948C5.22799 8.09284 5.1332 8.07399 5.03746 8.07399C4.94173 8.07399 4.84694 8.09284 4.7585 8.12948C4.67005 8.16611 4.58969 8.21981 4.522 8.2875C4.38529 8.42421 4.30849 8.60963 4.30849 8.80297C4.30849 8.9963 4.38529 9.18172 4.522 9.31843L6.92629 11.7227C6.99379 11.7907 7.07409 11.8447 7.16256 11.8816C7.25103 11.9184 7.34591 11.9374 7.44175 11.9374C7.53759 11.9374 7.63247 11.9184 7.72094 11.8816C7.80941 11.8447 7.88971 11.7907 7.95721 11.7227L12.9358 6.74293C13.0044 6.67552 13.059 6.59519 13.0964 6.50659C13.1337 6.41798 13.1532 6.32284 13.1537 6.22667C13.1541 6.1305 13.1355 6.03519 13.099 5.94624C13.0624 5.85728 13.0086 5.77645 12.9406 5.70841C12.8726 5.64036 12.7919 5.58645 12.703 5.54977C12.614 5.51309 12.5188 5.49438 12.4226 5.49472C12.3264 5.49505 12.2313 5.51442 12.1426 5.55171C12.054 5.58901 11.9736 5.64348 11.9061 5.712L7.44114 10.1769Z" fill="#28BE7F"/>
</svg>

          </span>
        </label>`;
    });

  $(".wishlist_collec_inner").html(rows.join(""));
  
  
  updateWishlistScrollIcon(); 
  $(".rdx_create_collection_btn").show();
  $(".create_collection_btn_secend").hide();
  $(".current_input_row").removeClass("rb_wishlist_hidden");
  $(".wishlist_collec_list").show();
  $(".wishlist_popup_main").addClass("active");
}
// click anywhere on the row selects it
$(document).on("click", ".wishlist_collec_box", function(e){
  if(!$(e.target).is('input[type="radio"]')) {
    $(this).find('input[name="collection_id"]').prop('checked', true).trigger('change');
  }
});

// when a radio is checked, update text and add .is-selected class
$(document).on("change", ".wishlist_collec_inner input[name='collection_id']", function(){
  const $box = $(this).closest('.wishlist_collec_box');
  const $list = $box.closest('.wishlist_collec_inner');

  // reset all
  $list.find('.wishlist_collec_box').removeClass('is-selected');
  $list.find('.wishlist_collec_subtitle').each(function(){
    const orig = $(this).attr('data-count');
    if(orig) $(this).text(orig);
  });

//   set selected
  $box.addClass('is-selected');
  $box.find('.wishlist_collec_subtitle').text('Saved in this collection');
});


function check_wish_collection_data() {
	$.ajax({
		url: `${window.apiUrl}/wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}&collectionItems=true`,
		method: "GET",
		headers: {
			"Content-Type": "application/json"
		},
	}).done(async function (response) {

		if (response.length > 0) {
			var collection_count = response.filter(function (collection) {
				return (collection && collection.totalItem > 0) || (collection && collection.items && collection.items.length > 0);
			}).length;
			$(".wishlist_collection_tab_count").text(`(${collection_count})`);
			localStorage.setItem("local_collection_list", JSON.stringify(response));
		}

	});
}
async function share_wishlist_data() {
	var url = window.location.href;
	var lastPart = url.split('/').pop(); // Extract the last part

	var token_list = lastPart.split('&')

	$.ajax({
		url: `${window.apiUrl}/wishlist/collection-by-token/${token_list}`,
		method: "GET",
		headers: {
			"Content-Type": "application/json"
		},
	}).done(async function (response) {

		if (response.length > 0) {
			jQuery.each(response, function (index, element) {

				$(".rb_wishlist_main").show();
				wishlist_collection_list(response, true);
			})
			jQuery('body').removeClass("rb_wishlist_empty");

		} else {
			wishlist_product_list()
			//        $(".rb_empty_wishlist").show();
			jQuery('body').addClass("rb_wishlist_empty");

			$(".wishlist_recent_pro").show();
			$(".rb_wishlist_main").hide();
		};
	});
}
async function getCollectionData(flag) {
	$.ajax({
		url: `${window.apiUrl}/wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}&collectionItems=${flag}`,
		method: "GET",
		headers: {
			"Content-Type": "application/json"
		},
	}).done(async function (response) {
		if (response.length > 0) {
			localStorage.setItem("local_collection_list", JSON.stringify(response));

			jQuery.each(response, function (index, element) {

				$(".rb_wishlist_main").show();
				wishlist_collection_list(response);
				jQuery(".rb_collection_share_header").show();
			})
			jQuery('body').removeClass("rb_wishlist_empty");

		} else {
			localStorage.setItem("local_collection_list", [""]);
			wishlist_product_list()
			//$(".rb_empty_wishlist").show();
			jQuery('body').addClass("rb_wishlist_empty")
			$(".wishlist_recent_pro").show();
			$(".rb_wishlist_main").hide();
		};
		syncWishlistEmptyState();
	});

}

function wishlist_collection_list(response, w_flag = false) {
	var hidden_class
	if (w_flag) {
		jQuery(".rb_wishlist_title").text("Shared Wishlist");
		hidden_class = "rb_wishlist_hidden";
		jQuery(".rb_collection_share_header").addClass("rb_wishlist_hidden");
		jQuery(".rb_wish_product_tab").addClass("rb_wishlist_hidden");
	}

	var collection_count = response.filter(function (collection) {
		return (collection && collection.totalItem > 0) || (collection && collection.items && collection.items.length > 0);
	}).length;
	$(".wishlist_collection_tab_count").text(`(${collection_count})`);
	const collections = response.map((element) => {
		const items = (element.items || []).slice(0, 4).map(
			(item) => `<img src="${item}" loading="lazy">`
		);
		const hasItems = (element && element.totalItem > 0) || (element && element.items && element.items.length > 0);
		return `
	   ${hasItems ? `
		 <div class="ct_collection_box">
		 <input type="checkbox" name="collection_id" class="rb_share_checkbox"  data-collection-id="${element.id}" data-collection-name="${element.name}">
			 <div class="ct_collection_checkbox"></div>
		   <div class="ct_collection_img rb_wishlist_collection_img" data-collection-id="${element.id}" data-collection-name="${element.name}">
			 <div class="ct_collection_img_box_wrap">${items.join("")}</div>
			 
		   </div>
		   <div class="ct_collection_bottom">
			 <div class="ct_collection_title">${element.name}</div>
			 <div class="ct_collection_subtitle">${element.totalItem} Products</div>
			 <div class="rb_wishlist_three_dot_btn ${hidden_class}" data-collection-id="${element.id}" data-collection-name="${element.name}" data-collection-token="${element.tokenKey}">
			 <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			   <g opacity="0.9">
				 <path d="M15 9.375C16.0355 9.375 16.875 8.53553 16.875 7.5C16.875 6.46447 16.0355 5.625 15 5.625C13.9645 5.625 13.125 6.46447 13.125 7.5C13.125 8.53553 13.9645 9.375 15 9.375Z" fill="#454545"/>
				 <path d="M15 16.875C16.0355 16.875 16.875 16.0355 16.875 15C16.875 13.9645 16.0355 13.125 15 13.125C13.9645 13.125 13.125 13.9645 13.125 15C13.125 16.0355 13.9645 16.875 15 16.875Z" fill="#454545"/>
				 <path d="M15 24.375C16.0355 24.375 16.875 23.5355 16.875 22.5C16.875 21.4645 16.0355 20.625 15 20.625C13.9645 20.625 13.125 21.4645 13.125 22.5C13.125 23.5355 13.9645 24.375 15 24.375Z" fill="#454545"/>
			   </g>
			 </svg>
			 </div>
		   </div>
		 </div>`: ""}`;
	});

	$(".rb_wishlist_collection_list").html(collections.join(""));
	$(".rdx_create_collection_btn").hide();
	$(".create_collection_btn_secend").show();
	$(".rb_wishlist_collection_list").show();
}
async function updateCollection(data) {
	try {
		const response = await $.ajax({
			url: `${window.apiUrl}/wishlist/collection`,
			method: "PUT",
			headers: {
				"Content-Type": "application/json"
			},
			data: JSON.stringify(data),
		});
		return response.success ? response : null;
	} catch {
		return null;
	}
}
async function deleteCollection(collectionId) {
	try {
		const response = await $.ajax({
			url: `${window.apiUrl}/wishlist/collection/${collectionId}`,
			method: "DELETE",
			headers: {
				"Content-Type": "application/json"
			}

		});
		return response.success ? response : null;
	} catch {
		return null;
	}
}
async function getProductData(productData, isCart) {
	var data = "";
	var url = window.location.href;
	var count_url = url.split("/").length;
	var hidden_class = "";
	if (count_url == 6) {
		hidden_class = "rb_wishlist_hidden";
	}
	jQuery.each(productData, function (index, element) {
		data += `<div class="ct_collection_product_box_item">
	 <div class="ct_collection_product_box_item_img rb_wishlist_product_details" data-name="${element.name}">
		 <img class="${!element.inventoryQuantity ? '' : 'rb_wishlist_product_details_img'}" data-handle="${element.handle}" width="500" height="500" src="${element.image}" alt="${element.name}">
		 <div class="rb_collection_wishlist_icon_main ${hidden_class}">
		   <div class="ct_hart_icon ct_hart_icon-media">
			 <div class="wishlist_img_main active" data-prod-id="${element.groupId}" data-prod-title="${element.name}" data-prod-featured-image="${element.image}" data-prod-variant-id="${element.id}" 
			 data-prod-price="${element.sellingPrice}"
			 data-prod-selling-price="${element.Price}"
			 >
			   <img class="wish_uncheck wishlist_blank_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_uncheck.webp?v=1734585398">
			   <img class="wish_fill wishlist_fill_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_fill.png">
			   
			 </div>
		   </div>
		   <div class="wish_added" style="display: none;">
			 <h2>Added To Wishlist</h2>
		   </div>
		   ${!element.inventoryQuantity ? 
			`<div class="prd_oos">
				<h2>Out Of Stock</h2>
			</div>` : ""}
		 </div>
	 </div>
	 <div class="ct_collection_product_box_item_title">
		 <span>${element.name}</span>
	 </div>
	 <div class="ct_collection_product_box_item_price">`;
		var discountPercentage = 0;
		var compare_price = 0;
		if (element.price > element.sellingPrice) {
			compare_price = element.price;
			discountPercentage = (element.price - element.sellingPrice) / element.price * 100;
			discountPercentage = Math.round(discountPercentage);
		}
		data += `<span class="discount_price">₹${element.sellingPrice}</span>
		 ${compare_price > 0 ? `<span class="original_price">₹${compare_price}</span>` : ""}
		 ${discountPercentage > 0 ? `<span class="discount_percentage">${discountPercentage}% OFF</span>` : ""}
	 </div>
	 <div class="ct_collection_product_box_addcart">
		<p class="prd-added-cart prd-added-cart-${element.id}" style="display: none;"> 
			<span> 
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
					<circle cx="16.0001" cy="16.0005" r="11.4286" fill="white"/>
					<path d="M16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0ZM14.0069 19.1566L10.4526 15.6C10.3252 15.4726 10.1739 15.3715 10.0074 15.3025C9.84092 15.2336 9.66249 15.1981 9.48229 15.1981C9.30209 15.1981 9.12365 15.2336 8.95717 15.3025C8.79069 15.3715 8.63942 15.4726 8.512 15.6C8.25466 15.8573 8.1101 16.2064 8.1101 16.5703C8.1101 16.9342 8.25466 17.2832 8.512 17.5406L13.0377 22.0663C13.1648 22.1943 13.3159 22.296 13.4825 22.3653C13.649 22.4347 13.8276 22.4704 14.008 22.4704C14.1884 22.4704 14.367 22.4347 14.5335 22.3653C14.7001 22.296 14.8512 22.1943 14.9783 22.0663L24.3497 12.6926C24.4788 12.5657 24.5816 12.4145 24.652 12.2477C24.7223 12.0809 24.759 11.9018 24.7599 11.7208C24.7607 11.5398 24.7257 11.3603 24.6569 11.1929C24.588 11.0255 24.4867 10.8733 24.3588 10.7452C24.2308 10.6172 24.0788 10.5157 23.9114 10.4466C23.7441 10.3776 23.5647 10.3424 23.3837 10.343C23.2027 10.3436 23.0235 10.3801 22.8567 10.4503C22.6898 10.5205 22.5385 10.623 22.4114 10.752L14.0069 19.1566Z" fill="#28BE7F"/>
				</svg>
			</span> 
			<span> Added To Cart </span> 
		<p>
	   	${!element.inventoryQuantity ? 
			`<button class="ct_wishlist_addcart_btn-disabled get-similar-products similar_pro" data-pagetype='wishlist' data-productname="${element.name}" cart_data-product-id="${element.sku}">
				<img src="https://cdn.shopify.com/s/files/1/0796/1959/files/view-similar_10825149-62bb-43f0-a783-3157b18c2c73.png?v=1736156298" width="50" height="50" alt="image">
				<span>View Similar</span>
			</button>` : 
			`<button class="ct_wishlist_addcart_btn ct_wishlist_addcart_btn-${element.id}" data-product-title="${element.name}" data-product-price="${element.sellingPrice}" data-prod-variant-id="${element.id}" data-isCart="${isCart}">Add to Cart</button>`}
	 </div>
   </div>`;
	})
	return data;
}
async function addProductToCart(variantId) {
    let formData = {
        'items': [{
            'id': variantId,
            'quantity': 1
        }]
    };

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        const data = await response.json();

        if (response.ok) {
            // If successful, update cart UI
            mmajaxcart.AjaxcartRender();
            setTimeout(() => {
                mmajaxcart.AjaxcartOpen();
                closeLoader();
            }, 500);
            return data;
        } else {
            closeLoader();
            return null;
        }
    } catch (error) {
        closeLoader();
        console.error('Error:', error);
        return null;
    }
}

// Keep the scrollbar pill in the correct vertical position
function syncWishlistScrollIconPosition() {
  const $inner = $(".wishlist_collec_inner");
  const $icon = $(".wishlist_scroll_icon");

  if (!$inner.length || !$icon.length) return;

  const el = $inner[0];
  const maxScroll = el.scrollHeight - el.clientHeight;
  if (maxScroll <= 0) {
    $icon.hide();
    return;
  } else {
    $icon.show();
  }

  const ratio = el.scrollTop / maxScroll;

  // Track area: height inside the list where the thumb can move
  const trackTop = $inner.position().top + 2;  // +2px padding
  const trackHeight = $inner.outerHeight() - $icon.outerHeight() - 4; // -4 for top/bottom padding

  const top = trackTop + ratio * trackHeight;
  $icon.css("top", top + "px");
}


// Create / remove the scrollbar pill and sync its position
function updateWishlistScrollIcon() {
  const $inner = $(".wishlist_collec_inner");
  if (!$inner.length) return;

  const $list = $inner.closest(".wishlist_collec_list");
  if (!$list.length) return;

  // Remove any previous icon
  $list.find(".wishlist_scroll_icon").remove();

  // Only show icon if there are more than 3 collections
  const boxCount = $inner.find(".wishlist_collec_box").length;
  if (boxCount <= 3) return;

  const el = $inner[0];
  const isScrollable = el.scrollHeight > el.clientHeight + 1;
  if (!isScrollable) return;

  // Append the scrollbar pill
  const iconHtml = `
    <div class="wishlist_scroll_icon" aria-hidden="true">
      <svg width="5" height="45" viewBox="0 0 5 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="5" height="45" rx="2.5" fill="#D9D9D9"/>
      </svg>
    </div>
  `;
  $list.append(iconHtml);

  // 🔹 Bind scroll directly on the inner list (no delegation)
  $inner.off("scroll.wishScroll").on("scroll.wishScroll", function () {
    syncWishlistScrollIconPosition();
  });

  // Position it according to current scroll
  syncWishlistScrollIconPosition();
}




jQuery(document).ready(function () {
	checkVisibilityAndCallAPI();
	// ---- Wishlist custom scrollbar drag state ----
// ---- Wishlist custom scrollbar drag state ----
    let wishScrollDragging = false;
    let wishScrollStartY = 0;
    let wishScrollStartTop = 0;

    // 4c - Start dragging scrollbar pill
    $(document).on("mousedown", ".wishlist_scroll_icon", function (e) {
      e.preventDefault();
      wishScrollDragging = true;
      wishScrollStartY = e.pageY;
      wishScrollStartTop = parseFloat($(this).css("top")) || 0;
    });

    // 4d - While dragging
    $(document).on("mousemove", function (e) {
      if (!wishScrollDragging) return;

      const $inner = $(".wishlist_collec_inner");
      const $icon = $(".wishlist_scroll_icon");
      if (!$inner.length || !$icon.length) return;

      const deltaY = e.pageY - wishScrollStartY;

      const trackTop = $inner.position().top + 2;
      const trackHeight = $inner.outerHeight() - $icon.outerHeight() - 4;

      let newTop = wishScrollStartTop + deltaY;

      if (newTop < trackTop) newTop = trackTop;
      if (newTop > trackTop + trackHeight) newTop = trackTop + trackHeight;

      $icon.css("top", newTop + "px");

      const el = $inner[0];
      const maxScroll = el.scrollHeight - el.clientHeight;
      const ratio = (newTop - trackTop) / trackHeight;
      el.scrollTop = ratio * maxScroll;
    });

    // 4e - Stop drag
    $(document).on("mouseup mouseleave", function () {
      wishScrollDragging = false;
    });





	// === Step 2: Create-prompt -> input toggle, autofocus and revert ===
// (Insert this inside your existing jQuery(document).ready(function () { ... }) block)


// Show the input row when user clicks "Create A New Collection" prompt
$(document).on('click', '.show_create_collection_trigger', function (e) {
  e.preventDefault();

  // 🔹 Clear any previously selected collection state
  $("input[name='collection_id']").prop("checked", false);
  $(".wishlist_collec_box").removeClass("is-selected");
  $(".wishlist_popup_bottom_btn").removeClass("select_collection_checked");

  // Hide the prompt button
  $('.create_collection_prompt').hide();
  $('.wish_added_thumb_wrap').hide();
   $('.wish_added_text').hide();
   $('.wishlist_popup_close').css({
    'position': 'absolute',
    'right': '15px',
    'top': '18px'
});


  // Hide all existing collection boxes when creating a new collection
  $('.wishlist_collec_inner').hide();
  $('.wishlist_scroll_icon').hide();

  // Show the input row (remove hidden class and aria)
  $('.current_input_row')
    .removeClass('rb_wishlist_hidden')
    .attr('aria-hidden', 'false');

  // Show revert control so user can cancel creating
  $('.rb_revert_create_wishlist').show();

  // Reset input state, counter and disable Create button until text typed
  $('.create_collection_input').val('');
  $('.ct_char span').text(0);

  // Header text for create mode
  $('.wishlist_popup_header h3')
    .text('Create A New Collection')
    .css('color', '#454545');

  // 🔹 In create mode: ONLY "Create Collection" should be visible
  $('.rdx_add_wish_btn').hide().prop('disabled', true);     // hide Add
  $('.rdx_create_collection_btn').show().prop('disabled', true); // show Create (disabled until text)

  // Focus the input after a tiny delay
  setTimeout(function () {
    const input = document.querySelector('.create_collection_input');
    if (input) {
      input.focus();
      try { input.setSelectionRange(0, 0); } catch (err) {}
    }
  }, 30);
});


// Revert/cancel create flow: hide input and show prompt again
$(document).on('click', '.rb_revert_create_wishlist', function (e) {
  e.preventDefault();

  // Hide revert & input, reset input contents
  $('.rb_revert_create_wishlist').hide();
  $('.current_input_row').addClass('rb_wishlist_hidden').attr('aria-hidden', 'true');
  $('.create_collection_input').val('');
  $('.ct_char span').text(0);
  $('.rdx_create_collection_btn').prop('disabled', true);

  // Show the prompt again
  $('.create_collection_prompt').show();
   // Show the collection list again
  $('.wishlist_collec_inner').show();
  updateWishlistScrollIcon();

  // 👇 ADD THESE TWO LINES HERE
  $('.rdx_create_collection_btn').hide().prop('disabled', true);
  $('.rdx_add_wish_btn').show().prop('disabled', true);

  // Reset header text
  $('.wishlist_popup_header h3').text('Organise Your Wishlist').css('color', '');
});

// Make sure this exists somewhere near the top of your file:
// var wishlistAutoAddTimer = null;   // ---> global timer for auto-add

// If a collection radio is selected, hide create prompt/input (user chose existing collection)
$(document).on('change', '.wishlist_collec_inner input[name="collection_id"]', function () {
  const checked_count = jQuery("input[name='collection_id']:checked").length;
  const $btn = $('.rdx_add_wish_btn');             // ---> Add to Collection button
  const ANIM_TIME = 2000; // ms  (3s gradient fill) --->

  // ---- reset any previous timers / animation first ----
  if (wishlistAutoAddTimer) {                      // --->
    clearTimeout(wishlistAutoAddTimer);            // --->
    wishlistAutoAddTimer = null;                   // --->
  }                                                // --->
  if ($btn.data('animTimeoutFill')) {              // --->
    clearTimeout($btn.data('animTimeoutFill'));    // --->
    $btn.removeData('animTimeoutFill');            // --->
  }                                                // --->

  if (checked_count > 0) {
    // Hide prompt and input to reduce clutter
    $('.create_collection_prompt').show();
    $('.current_input_row').addClass('rb_wishlist_hidden').attr('aria-hidden', 'true');
    $('.rb_revert_create_wishlist').hide();

    // Enable and show Add button
    $('.rdx_add_wish_btn').show().prop('disabled', false);
    // Hide Create button
    $('.rdx_create_collection_btn').hide().prop('disabled', true);

    // Visual selection state
    $('.wishlist_popup_bottom_btn').addClass('select_collection_checked');

    // ---------- NEW: start button fill animation ----------
    $btn
      .removeClass('fill-complete')               // ---> reset state
      .addClass('is-animating')                   // ---> makes bg white + starts ::before fill
      .text('Adding to Collection…');             // ---> temp text

    const fillTimeout = setTimeout(function () {  // ---> when fill completes
      $btn.addClass('fill-complete');             // ---> (optional) text color to white
    }, ANIM_TIME);
    $btn.data('animTimeoutFill', fillTimeout);    // ---> store so we can clear later

    // ---------- auto-click "Add to Collection" after 0.5s ----------
    wishlistAutoAddTimer = setTimeout(function () { // --->
      const stillSelected = jQuery("input[name='collection_id']:checked").length > 0; // --->
      if (stillSelected && !$btn.prop('disabled')) { // ---> safety checks
        $btn.trigger('click');                      // ---> simulate button click
      }                                             // --->
    }, 2000); // 0.5s delay  --->

  } else {
    // No selection -> show prompt again
    $('.create_collection_prompt').show();
    $('.current_input_row').addClass('rb_wishlist_hidden').attr('aria-hidden', 'true');
    $('.rb_revert_create_wishlist').hide();

    // Keep Add visible but disabled
    $('.rdx_add_wish_btn').show().prop('disabled', true);
    // Keep Create hidden
    $('.rdx_create_collection_btn').hide().prop('disabled', true);

    // Remove selection state class
    $('.wishlist_popup_bottom_btn').removeClass('select_collection_checked');
    $('.skip_btn').show();

    // ---> cancel auto-add if user unselects / changes quickly
    if (wishlistAutoAddTimer) {                     // --->
      clearTimeout(wishlistAutoAddTimer);           // --->
      wishlistAutoAddTimer = null;                  // --->
    }                                               // --->

    // ---> reset button visual + text
    $btn
      .removeClass('is-animating fill-complete')    // --->
      .text('Add to Collection');                   // --->
  }
});




// Ensure typing in the create input enables/disables the Create button (redundant-safe)
$(document).on('input', '.create_collection_input', function () {
  const hasText = $(this).val().trim().length > 0;
  $('.rdx_create_collection_btn').prop('disabled', !hasText);
  $(this).parent().find('.ct_char span').text($(this).val().length);
});

// === Step 3: Ensure popup opens with prompt visible and input hidden ===
// Insert this inside your existing jQuery(document).ready(...) block

// === Step 6: Initial popup state with "no-collections" check ===
// Replace any previous setWishlistPopupInitialState() + MutationObserver block with this one

function setWishlistPopupInitialState() {

  // ---> Always reset "Add to Collection" button when popup (re)opens
  $('.rdx_add_wish_btn')
    .removeClass('is-animating fill-complete')  // ---> stop any previous animation classes
    .text('Add to Collection')                  // ---> back to default label
    .prop('disabled', true);                    // ---> disabled until user selects a collection

  // ---> cancel delayed auto–add timer (if any) when popup resets
  if (typeof wishlistAutoAddTimer !== 'undefined' && wishlistAutoAddTimer) { // --->
    clearTimeout(wishlistAutoAddTimer);                                      // --->
    wishlistAutoAddTimer = null;                                             // --->
  }                                                                          // --->

  // Helper: whether a collection exists in the DOM
  function hasCollectionsInDOM() {
    try {
      const node = document.querySelector('.wishlist_collec_inner');
      if (!node) return false;
      // count only actual collection rows (labels) or inputs
      const radios = node.querySelectorAll('input[name="collection_id"]');
      if (radios && radios.length > 0) {
        // if any radio exists and not all are empty, consider collections present
        return Array.from(radios).some(r => r.getAttribute('data-collection-id'));
      }
      // fallback: if innerHTML has non-empty trimmed text or image nodes, treat as present
      return node.children && node.children.length > 0;
    } catch (err) {
      return false;
    }
  }

  // Helper: whether localStorage has known collection list (fallback)
  function hasCollectionsInLocalStorage() {
    try {
      const raw = localStorage.getItem('local_collection_list');
      if (!raw) return false;
      let parsed;
      try { parsed = JSON.parse(raw); } catch (_) { return false; }
      return Array.isArray(parsed) && parsed.length > 0 && parsed.some(el => el && (el.id || el.name || (Array.isArray(el.items) && el.items.length>0)));
    } catch (err) {
      return false;
    }
  }

  const collectionsExist = hasCollectionsInDOM() || hasCollectionsInLocalStorage();

  if (collectionsExist) {
    // Collections exist → show collection list & prompt, hide text input
    $('.create_collection_prompt').show();
    $('.wishlist_collec_inner').show();
  
    $('.current_input_row')
      .addClass('rb_wishlist_hidden')
      .attr('aria-hidden', 'true');
    $('.rb_revert_create_wishlist').hide();
    $('.ct_char span').text(0);

    // Header text & color
    $('.wishlist_popup_header h3')
      .text('Organise Your Wishlist')
      .css('color', '');

    // Buttons: show Add (disabled), hide Create
    $('.rdx_add_wish_btn').show().prop('disabled', true);
    $('.rdx_create_collection_btn').hide().prop('disabled', true);
    updateWishlistScrollIcon();
  } else {
    // No collections → show create mode directly
    $('.wishlist_popup_header h3')
      .text('Create A New Collection')
      .css('color', '#454545');

    $('.create_collection_prompt').hide();
    $('.current_input_row')
      .removeClass('rb_wishlist_hidden')
      .attr('aria-hidden', 'false');
    $('.rb_revert_create_wishlist').show(); // allow revert if needed
    $('.create_collection_input').val('');
    $('.ct_char span').text(0);

    // Buttons: show Create (disabled), hide Add
    $('.rdx_create_collection_btn').show().prop('disabled', true);
    $('.rdx_add_wish_btn').hide().prop('disabled', true);

    $('.wishlist_scroll_icon').remove();
    // Focus the input (small timeout to ensure it's visible)
    setTimeout(function () {
      const input = document.querySelector('.create_collection_input');
      if (input) {
        input.focus();
        try { input.setSelectionRange(0, 0); } catch (e) { /* ignore */ }
      }
    }, 40);
  }
}



// Observe the wishlist popup element for when it becomes active/open
(function() {
  const popup = document.querySelector('.wishlist_popup_main');
  if (!popup) return;

  // Run once now to ensure initial state (handles case popup already open)
  setWishlistPopupInitialState();

  // Create observer to watch for class changes (so we re-run check whenever popup opens)
  const observer = new MutationObserver(function(mutationsList) {
    for (let mut of mutationsList) {
      if (mut.type === 'attributes' && mut.attributeName === 'class') {
        const isActive = popup.classList.contains('active');
        if (isActive) {
        // popup opened
        document.body.classList.add('rb-wishlist-no-scroll');
        setWishlistPopupInitialState();
      } else {
        // popup closed
        document.body.classList.remove('rb-wishlist-no-scroll');
      }
      }
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class'] });

})();

	//var uniqueId = getCookie("browserUniqueId") || generateUniqueId();





	// if (__st.pageurl.indexOf("search") == -1) {
	// 	wishlist_product_list();
	// } else {
	// 	setTimeout(() => {
	// 		wishlist_product_list();
	// 	}, 2000);
	// }


	// Wishlist Product

	// Event handlers
	$(document).on("click", ".ct_hart_icon_main .wishlist_blank_icon", async function () {
		const $parent = $(this).parent();

		// Extract product details
		const productType = $parent.attr("data-prod-metafiled-type") || $parent.attr("data-prod-type");
		currentProId = $parent.attr("data-prod-title");
		productItemData = {
			groupId: $parent.attr("data-prod-id"),
			name: currentProId,
			sellingPrice: $parent.attr("data-prod-price"),
			price: $parent.attr("data-prod-selling-price"),
			image: $parent.attr("data-prod-featured-image"),
			variantId: $parent.attr("data-prod-variant-id"),
            sku: $parent.attr("data-prod-sku"),
			url: $parent.attr("data-url") || "",
			category: productType || "",
			subCategory: $parent.attr("data-subcategory") ||  "",
			customerEmail: "",
			accessToken: "",
			customerId: customerId,
			registrationId: uniqueId,
			device: "WEB",
			version: "2.4",
			collectionName: "",
		};

        let everyProdWish = {
            "sku": productItemData.sku,
            "product_title": productItemData.name,
            "page": window.page,
			"image": productItemData.image,
			"price": productItemData.price,
			"productUrl": productItemData.url,
			"productCategory": productItemData.category,
			"productSubCategory": productItemData.subCategory
        }
        clevertap.event.push("Wishlisted", everyProdWish);
		collectionData = {
			name: productType,
			customerEmail: "",
			accessToken: "",
			customerId: customerId,
			registrationId: "",
			device: "WEB",
			version: "2.4",
		};

		// Fetch local collection list
		let collectionList = localStorage.getItem("local_collection_list") ? JSON.parse(localStorage.getItem("local_collection_list")) : "";
		if (!collectionList || collectionList.length === 0) {

			collectionList = await fetchCollectionList(uniqueId, customerId);
			if (collectionList) {
				localStorage.setItem("local_collection_list", JSON.stringify(collectionList));
			}
		} else {
			collectionList = collectionList;
		}

		// Find or create a collection
		const result = collectionList?.filter(obj => obj.name === productType && obj.totalItem >= 1) || [];

		if (result.length > 0) {
			productItemData.collectionName = result[0].name;

			// Add product to the collection
			const added = await addProductToCollection(productItemData);
			if (added && added[1]) {
				updateWishlistUI(added[1], $parent);
				updateLocalWishlist($parent.attr("data-prod-variant-id"));
				collectionList = await fetchCollectionList(uniqueId, customerId);
				if (collectionList) {
					localStorage.setItem("local_collection_list", JSON.stringify(collectionList));
				}
			}
		} else {
			showCollectionPopup(collectionList);
		}
	});



	jQuery(document).on("click", ".rb_revert_create_wishlist", function () {
		jQuery("input[name='collection_id']:checked").prop("checked", false);
		jQuery(".wishlist_popup_bottom_btn").removeClass("select_collection_checked");
		jQuery(".rdx_add_wish_btn").prop("disabled", true);
		jQuery(".current_input_row").removeClass("rb_wishlist_hidden");

	})
	jQuery(document).on("change", ".wishlist_collec_inner .wishlist_collec_box input[name='collection_id']", function () {
		var checked_count = jQuery("input[name='collection_id']:checked").length;
		if (checked_count > 0) {
			jQuery(".wishlist_popup_bottom_btn").addClass("select_collection_checked");
			jQuery(".rdx_add_wish_btn").prop("disabled", false);
			jQuery(".current_input_row").addClass("rb_wishlist_hidden");
		} else {
			jQuery(".current_input_row").removeClass("rb_wishlist_hidden");
		}
	})

	jQuery(document).on("click", ".rdx_add_wish_btn", async function () {

	if (!currentProId) return alert("No product ID selected.");

	var Collection_name = jQuery("input[name='collection_id']:checked").attr("data-collection-name");
	productItemData.collectionName = Collection_name;
	productItemData.registrationId = uniqueId;
	const added = await addProductToCollection(productItemData);

	if (added[0]) {
		jQuery(".wishlist_popup_bottom_btn").removeClass("select_collection_checked");
		$(".wishlist_popup_main").removeClass("active");
		$(".create_collection_input").val("");
		$(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
		jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
			.closest(".ct_hart_icon_main")
			.find(".wish_added")
			.show();
		setTimeout(() => {
			jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
				.closest(".ct_hart_icon_main")
				.find(".wish_added")
				.hide();
		}, 2000);
		var count = jQuery(".rb_wishlist_count").text();
		var total_count = parseInt(count) + 1;
		//jQuery(".rb_wishlist_count").text(total_count);
		jQuery(".rb_wishlist_count").addClass("rb_active_wish");
			
		collectionList = await fetchCollectionList(uniqueId, customerId);
		if (collectionList) {
			localStorage.setItem("local_collection_list", JSON.stringify(collectionList));
		}

		// ---> RESET add button + animation state after successful add
		$('.rdx_add_wish_btn')
		  .removeClass('is-animating fill-complete')  // ---> stop gradient animation flags
		  .text('Add to Collection')                  // ---> back to default label
		  .prop('disabled', true);                    // ---> disabled until next collection select

		// ---> also clear any pending auto-add timer (safety)
		if (typeof wishlistAutoAddTimer !== 'undefined' && wishlistAutoAddTimer) {
		  clearTimeout(wishlistAutoAddTimer);        // --->
		  wishlistAutoAddTimer = null;               // --->
		}

	} else {
		alert("Failed to add product to collection.");
	}

});


	jQuery(document).on("click", ".ct_hart_icon_main .wishlist_fill_icon", function () {
		const $parent = $(this).parent();
		const groupId = $parent.attr("data-prod-variant-id");
        const $prodSku=$parent.attr("data-prod-sku");
		$.ajax({
			url: `${window.apiUrl}/customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
			method: "DELETE",
			headers: {
				"Content-Type": "application/json"
			},
		}).done(async function (response) {
			if (response.success) {
                var removeWishlisted = {
				"sku": $prodSku
			}
			clevertap.event.push("Wishlist Item Removed", removeWishlisted);
            sessionStorage.setItem("wishlistFetched", "false");
				uncheck_wishlist_added(groupId);
				var localProductData = localStorage.getItem("local_wish_prod_data");
				localProductData = localProductData ? JSON.parse(localProductData) : [];

				// Remove the specified variantId
				const index = localProductData.indexOf(groupId);
				if (index !== -1) {
					localProductData.splice(index, 1); // Remove the variantId from the array
					localStorage.setItem("local_wish_prod_data", JSON.stringify(localProductData));
				}
				var count = jQuery(".rb_wishlist_count").text();
				var total_count = parseInt(count) - 1;
				//jQuery(".rb_wishlist_count").text(total_count);
				var req = getCollectionData(false);
				if (req && typeof req.always === 'function') {
					req.always(function () {
						syncWishlistEmptyState();
					});
				} else {
					syncWishlistEmptyState();
				}

				clevertap.event.push("wishlist item removed");
			}
		});
	});
	jQuery(document).on("click", ".rb_collection_wishlist_icon_main .wishlist_fill_icon", function () {
		const $parent = $(this).parent();
		const groupId = $parent.attr("data-prod-variant-id");
		var $this = $(this);

		$.ajax({
			url: `${window.apiUrl}/customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
			method: "DELETE",
			headers: {
				"Content-Type": "application/json"
			},
		}).done(async function (response) {
			if (response.success) {
                sessionStorage.setItem("wishlistFetched", "false");
				var data = await uncheck_wishlist_added(groupId);
				var localProductData = localStorage.getItem("local_wish_prod_data");
				localProductData = localProductData ? JSON.parse(localProductData) : [];
				// Remove the specified variantId
				const index = localProductData.indexOf(groupId);
				if (index !== -1) {
					localProductData.splice(index, 1); // Remove the variantId from the array
					localStorage.setItem("local_wish_prod_data", JSON.stringify(localProductData));
				}
				setTimeout(function () {

					$this.closest(".ct_collection_product_box_item").remove();
					if (jQuery(".rb_wishlist_all_product_list .ct_collection_product_box_item").length == 0) {
						jQuery(".rb_wishlist_collection_product_list").hide();
						$.when(getCollectionData(true), wishlist_product_list()).always(function () {
							syncWishlistEmptyState();
						});

						//checkVisibilityAndCallAPI()


					} else {

						wishlist_product_list();
						check_wish_collection_data();
						//checkVisibilityAndCallAPI()
						syncWishlistEmptyState();
					}
				}, 500)


			}
		});
	});



	$(document).on("click", ".wishlist_popup_close, .wishlist_popup_bottom_btn .skip_btn", async function () {
		const $this = $(this);

		// Prevent multiple clicks by disabling the button temporarily
		if ($this.data('processing')) return;
		$this.data('processing', true);

		if (!currentProId) {
			$this.data('processing', false);
			return alert("No product ID selected.");
		}


		collectionData.registrationId = uniqueId;

		try {
			// const collectionResponse = await createCollection(collectionData);
			// var collection_create = {
			// 	"folder_name": collectionData.name,
			// 	"created_from": __st.p == "page" ? "Wishlist Page" : __st.p
			// }
			// clevertap.event.push("wishlist folder created", collection_create);
			// if (!collectionResponse) {
			// 	$this.data('processing', false);
			// 	return alert("Failed to create collection.");
			// }

			productItemData.collectionName = collectionData.name;
			productItemData.registrationId = uniqueId;
			const added = await addProductToCollection(productItemData);

			if (added[0]) {
				$(".wishlist_popup_main").removeClass("active");
				$(".create_collection_input").val("");
				$(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
				jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
					.closest(".ct_hart_icon_main")
					.find(".wish_added")
					.show();
				setTimeout(() => {
					jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
						.closest(".ct_hart_icon_main")
						.find(".wish_added")
						.hide();
				}, 2000);

				var count = jQuery(".rb_wishlist_count").text();
				var total_count = parseInt(count) + 1;
				// jQuery(".rb_wishlist_count").text(total_count);
				jQuery(".rb_wishlist_count").addClass("rb_active_wish");

				collectionList = await fetchCollectionList(uniqueId, customerId);
				if (collectionList) {
					localStorage.setItem("local_collection_list", JSON.stringify(collectionList));
				}
			} else {
				alert("Failed to add product to collection.");
			}
		} catch (error) {
			alert("An error occurred. Please try again.");
		} finally {
			// Re-enable the button after the operation completes
			$this.data('processing', false);
		}
		  // ----- ADD THIS RESET BLOCK RIGHT HERE -----
  setTimeout(function () {
    // show collection list again (in case create mode had hidden it)
    $('.wishlist_collec_inner').show();

    // re-run initial-state function if available
    if (typeof setWishlistPopupInitialState === 'function') {
      setWishlistPopupInitialState();
    } else {
      // fallback minimal reset
      $('.create_collection_prompt').show();
      $('.current_input_row').addClass('rb_wishlist_hidden').attr('aria-hidden', 'true');
      $('.rb_revert_create_wishlist').hide();
      $('.rdx_add_wish_btn').show().prop('disabled', true);
      $('.rdx_create_collection_btn').hide().prop('disabled', true);
      $('.wishlist_popup_header h3').text('Organise Your Wishlist').css('color', '');
    }
  }, 40);
	});


	$(document).on("click", ".rdx_create_collection_btn", async function () {
		const $this = $(this);

		// Prevent multiple clicks by disabling the button temporarily
		if ($this.prop("disabled")) return;
		$this.prop("disabled", true);



		var pd_type = $(".create_collection_input").val();
		collectionData.name = pd_type;
		collectionData.registrationId = uniqueId;

		try {
			//const collectionResponse = await createCollection(collectionData);
			// Handle response if necessary (e.g., collectionResponse.status)

			productItemData.collectionName = collectionData.name;
			productItemData.registrationId = uniqueId;

			var collection_create = {
				"folder_name": collectionData.name,
				"created_from": __st.p == "page" ? "Wishlist Page" : __st.p
			}
			clevertap.event.push("wishlist folder created", collection_create);

			const added = await addProductToCollection(productItemData);

			if (added) {
				$(".rb_wishlist_count").addClass("rb_active_wish");
				jQuery(".current_input_row").removeClass("has-focus");
				jQuery(".ct_char span").text(0);

				$(".wishlist_popup_main").removeClass("active");
				$(".create_collection_input").val("");
				$(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
				jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
					.closest(".ct_hart_icon_main")
					.find(".wish_added")
					.show();
				setTimeout(() => {
					jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
						.closest(".ct_hart_icon_main")
						.find(".wish_added")
						.hide();
				}, 2000);

				collectionList = await fetchCollectionList(uniqueId, customerId);
				if (collectionList) {
					localStorage.setItem("local_collection_list", JSON.stringify(collectionList));
				}
				// Optionally update the wishlist count or UI here
			} else {
				alert("Failed to add product to collection.");
			}
		} catch (error) {
			alert("An error occurred. Please try again.");
		} finally {
			// Re-enable the button after the operation completes
			$this.prop("disabled", false);
		}
	});


	$(document).on("input", ".create_collection_input", function () {
		toggleButtonState(".create_collection_input", ".rdx_create_collection_btn");
		jQuery(this).parent().find(".ct_char span").text($(this).val().length);
	});
	$(document).on("input", ".rb_wishlist_collection_name", function () {
		toggleButtonState(".rb_wishlist_collection_name", ".rb_wishlist_rename_save_btn");

		jQuery(this).parent().find(".ct_char span").text($(this).val().length);
	})

	// $("#current").keyup(function () {
	//   $(".ct_char span").text($(this).val().length);
	// });

	jQuery("input, select, textarea,email,password,tel").each(function (index) {
		var input = jQuery(this);
		input.on("focus", function () {
			jQuery(this).parent().addClass("has-focus");
		});

		input.on("focusout", function () {
			if (jQuery(this).val() == "") {
				jQuery(this).parent().removeClass("has-focus");
			}
		});
	});

	jQuery('input[type="text"],input[type="email"],input[type="password"],input[type="tel"],input[type="search"], select, textarea').each(function (index) {
		var input = jQuery(this);
		if (input.val() == "") {
			jQuery(input).parent().removeClass("has-focus");
		} else {
			jQuery(input).parent().addClass("has-focus");
		}
	});


	jQuery(document).on("click", ".rb_wishlist_three_dot_btn", function () {
		collectionId = jQuery(this).attr("data-collection-id");
		collectionName = jQuery(this).attr("data-collection-name");
		collectionToken = jQuery(this).attr("data-collection-token");
		jQuery(".rb_share_wishlist_title").text(collectionName);
		$(".rb_wishlist_three_dot_popup").show();
		jQuery(".rb_wishlist_share_box_main").show();
		jQuery(".rb_wishlist_edit_popup").hide();
		jQuery(".rb_wishlist_delete_popup").hide();
	})
	jQuery(document).on("click", ".wishlist_share_popup_bg", function () {
		$(".rb_wishlist_three_dot_popup").hide();
	})
	jQuery(document).on("click", ".rb_rename_collection_btn", function () {
		jQuery(".rb_wishlist_collection_name").val(collectionName);
		jQuery(".rb_wishlist_edit_popup").attr("data-collectionName", collectionName);
		jQuery(".rb_wishlist_collection_name").parent().find(".ct_char span").text(collectionName.length);
		jQuery(".rb_wishlist_collection_name").focus();
		jQuery(".rb_wishlist_collection_name").parent().addClass("has-focus");
		jQuery(".rb_wishlist_share_box_main").hide();
		jQuery(".rb_wishlist_edit_popup").show();
		jQuery(".rb_wishlist_hidden").css("display", "block");

	})
	jQuery(document).on("click", ".rb_wishlist_cancel_btn", function () {
		jQuery(".rb_wishlist_edit_popup").hide();
		jQuery(".rb_wishlist_share_box_main").show();
	})
	jQuery(document).on("click", ".rb_wishlist_rename_save_btn", async function () {
		var collectionName = jQuery(".rb_wishlist_collection_name").val();
		var data = {
			"id": collectionId,
			"name": collectionName,
			"customerId": customerId,
			"registrationId": uniqueId
		}

		const collectionResponse = await updateCollection(data);
		var old_coll_name = jQuery(".rb_wishlist_edit_popup").attr("data-collectionname");
		var rename_collection = {
			"old_folder_name": old_coll_name,
			"new_folder_name": collectionName
		}
		clevertap.event.push("wishlist folder renamed", rename_collection);
		if (!collectionResponse) {
			alert("Failed to update collection.");
		} else {
			getCollectionData(false);
			jQuery(".rb_wishlist_share_box_main").show();
			jQuery(".rb_wishlist_edit_popup").hide();
			$(".rb_wishlist_three_dot_popup").hide();
		}

	})


	jQuery(document).on("click", ".rb_delete_collection_btn", async function () {

		jQuery(".rb_wishlist_delete_popup").show();
		jQuery(".rb_wishlist_share_box_main").hide();

	});
	jQuery(document).on("click", ".rb_wishlist_delete_cancel_btn", function () {
		jQuery(".rb_wishlist_delete_popup").hide();
		jQuery(".rb_wishlist_share_box_main").show();
	});

	jQuery(document).on("click", ".rb_wishlist_delete_save_btn", async function () {

		var collection_delete = {
			"folder_name": collectionName
		}
		clevertap.event.push("wishlist folder deleted", collection_delete);
		const collectionResponse = await deleteCollection(collectionId);
		if (!collectionResponse) {
			alert("Failed to delete collection.");
		} else {
            sessionStorage.setItem("wishlistFetched", "false");
			getCollectionData(true);
			jQuery(".rb_wishlist_three_dot_popup").hide();
			wishlist_product_list();
		}
	});



	jQuery(document).on("click", ".wishlist_tab_list li a", function () {
      showLoader();
		var url = window.location.href;
		var count_url = url.split("/").length;
		var hidden_class = "";
		if (count_url == 6) {
			// checking the sharewishlist page condition
		} else {
			jQuery(".wishlist_tab_list li a").removeClass("active");
			jQuery(this).addClass("active");
			var href_class = jQuery(this).attr("data-tab");
			var data_id = jQuery(this).attr("data-id");
			$(href_class).show();
			if (data_id == 2) {
				jQuery(".rb_collection_share_header").hide();
				jQuery(".wishlist_tab_content").removeClass("wishlist_share_active");
				$.ajax({
					url: `${window.apiUrl}/customer/wishlist?registrationId=${uniqueId}&customerId=${customerId}`,
					method: "GET",
					headers: {
						"Content-Type": "application/json"
					},
				}).done(async function (response) {
                    closeLoader();
					var data = await getProductData(response, false);
					jQuery(".rb_wishlist_all_product_list").html(data);
					$(".rb_wishlist_collection_list").hide();
					$(".rb_wishlist_all_product_list").show();
					$(".rb_wishlist_collection_product_list").hide();
				});

			} else if (data_id == 1) {

				getCollectionData(true);
                jQuery(".loader-kushals").css("display","none");
				$(".rb_wishlist_collection_list").show();
				$(".rb_wishlist_all_product_list").hide();
			}
		}

	})


	jQuery(document).on("click", ".rb_wishlist_collection_img", async function () {
		var collectionId = jQuery(this).attr("data-collection-id");
		var collectionName = jQuery(this).attr("data-collection-name");

		$.ajax({
			url: `${window.apiUrl}/wishlist/collection/${collectionId}`,
			method: "GET",
			headers: {
				"Content-Type": "application/json"
			},
		}).done(async function (response) {
			jQuery(".rb_collection_share_header").hide();

			var data = `<div class="ct_product_bc_btn rb_collection_back_btn">
                  <div class="ct_product_bc_btn_inner ">
                      <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.376546 8.62345C-0.125528 8.12138 -0.125528 7.30726 0.376546 6.80519L6.80513 0.376574C7.30725 -0.125525 8.12131 -0.125525 8.62343 0.376574C9.12552 0.878687 9.12552 1.69275 8.62343 2.19486L3.10394 7.71432L8.62342 13.2338C9.12552 13.7359 9.12552 14.55 8.62342 15.0521C8.12131 15.5541 7.30724 15.5541 6.80513 15.0521L0.376546 8.62345Z" fill="#454545"/>
                      </svg>
                      <span>${response.name}</span>
                  </div>
              
              </div>`;
			data += `<div class="rb_wishlist_collection_product_list_inner rb_wishlist_all_product_list rb_collection_wishlist_icon_main">`;
			data += await getProductData(response.items);

			$(".rb_wishlist_collection_product_list").html(`${data}</div>`);
			$(".rb_wishlist_collection_list").hide();
			$(".rb_wishlist_collection_product_list").show();

		});
	})

	jQuery(document).on("click", ".rb_collection_back_btn", function () {
		var url = window.location.href;
		var count_url = url.split("/").length;
		if (count_url == 6) {
			share_wishlist_data()
		} else {
			var get_collection_list = JSON.parse(localStorage.getItem("local_collection_list"));
			if (get_collection_list.length > 0) {
				jQuery.each(get_collection_list, function (index, element) {

					$(".rb_wishlist_main").show();
					wishlist_collection_list(get_collection_list);
					jQuery(".rb_collection_share_header").show();
				})
				jQuery('body').removeClass("rb_wishlist_empty");

			}

		}
		$(".rb_wishlist_collection_product_list").hide();
		$(".rb_wishlist_collection_list").show();
	})
  
	jQuery(document).on("click", ".rb_add_to_cart, .ct_wishlist_addcart_btn", async function (e) { 
		showLoader();
		const $this = jQuery(this); // Use const for variables that won't be reassigned
		const variantId = $this.attr("data-prod-variant-id");
		const pdpProductTitle = $this.attr("data-product-title");
		const productPrice = $this.attr("data-product-price");
		const isCartProduct = $this.attr("data-iscart");
		const data = await addProductToCart(variantId);
		if (data) {
			jQuery(".fetch_pro_pop_main").removeClass("active");
			if (isCartProduct === 'true') {
				const shopifyAjaxCartURL = `${theme.routes.cart_url}.js`;
				$.get(shopifyAjaxCartURL, function (cartData) {
					const cartDataJSON = $.parseJSON(cartData);
	
					const cartItems = cartDataJSON.items;
					const cartPrd = cartItems.map((el) => el.product_title); 
	
					const cleanedTotalPrice = Math.floor(cartDataJSON.total_price) / 100;
					const finalPrice = cleanedTotalPrice + Number(productPrice);
	
					clevertap.event.push("ATC_Cart_Wishlist", {
						"Product name": pdpProductTitle,
						"Product price": productPrice,
						"cart Products": cartPrd.join(","),
						"cart after value": finalPrice,
						"Cart Value": theme.Shopify.formatMoney(cartDataJSON.total_price, theme.money_format_with_cart_code_preference),
					});
				});
			} else {
				clevertap.event.push("Add from wishlist to cart", {
					"Product name": pdpProductTitle,
					"Variant ID": variantId,
					"Product Price": productPrice,
				});
			}
		}
	});


	if(window.page === 'page') {
		$(document).on('click', '.rb_wishlist_product_details .rb_wishlist_product_details_img ', function () {
			let s = $(this).attr('alt');
			if ($(".fet_preview").hasClass("slick-initialized")) {
				jQuery(".fet_preview").slick("unslick");
			}
			var data_handle = s.toLowerCase().replace(/[ .]/g, "-");
	
			let ajax_url = `${window.location.origin}/products/${data_handle}.js`;
			$.get(ajax_url, function (data) {
				var d = jQuery.parseJSON(data);
				var product_open = {
					"product_id": d.name,
					"product_name": d.title
				}
				clevertap.event.push("wishlist item clicked", product_open);
				var variantId = d.variants[0].id;
				var title = document.querySelector('.fet_title');
				if(title) title.innerText = d.title;
	
				var price = document.querySelector('.fet_price')
				if (price) {
					const sellingPrice = parseInt(d.price / 100);
					const compareAtPrice = parseInt((d.compare_at_price || 0) / 100);
					const hasDiscount = compareAtPrice > sellingPrice;
					const discountPercentage = hasDiscount ? Math.round(((compareAtPrice - sellingPrice) / compareAtPrice) * 100) : 0;
					price.innerHTML = `₹ ${sellingPrice}${hasDiscount ? ` <span class="original_price"><s>₹ ${compareAtPrice}</s></span> <span class="discount_percentage">${discountPercentage}% OFF</span>` : ''}`;
				}
	
	
				var link = document.querySelector('.fet_link')
				var link_1 = window.location.origin;
				if(link && link_1) link.href = link_1 + d.url;
	
				var imgTag = "";
				d.images.forEach(function (image) {
					imgTag += `<div class="slide_img"><img src="${image}" alt="Preview Image"  /></div>`;
				});
				jQuery(".rb_add_to_cart").attr("data-prod-variant-id", variantId);
				$('.fet_preview').html(imgTag);
	
				$('.fet_preview').slick({
					slidesToShow: 1,
					variableWidth: true,
					dots: true
				});
				$(".fetch_pro_pop_main").addClass("active");
			});
		});
	}
	$(document).on('click', '.fetch_pro_pop_close', function () {
		$(this).closest('.fetch_pro_pop_main').removeClass('active');
	});
	jQuery(document).on("click", ".rb_share_collection_btn", function () {
		var share_wishlist = {
			"shared_folder_name": JSON.stringify(collectionName)
		}
		clevertap.event.push("wishlist item shared", share_wishlist);
		navigator.share({
			title: collectionName,
			url: `${window.location.origin}/pages/wishlist/${collectionToken}`
		})
		jQuery(".rb_wishlist_three_dot_popup").hide();
	})

	jQuery(document).on("click", ".rb_share_btn", function () {
		jQuery("input[name='collection_id']").prop("checked", false);
		jQuery(".rb_share_all_collection_btn").prop("disabled", true);
		jQuery(".wishlist_tab_content").addClass("wishlist_share_active")
	})
	jQuery(document).on("click", ".ct_shere_bc_btn_inner", function () {
		jQuery("input[name='collection_id']").prop("checked", false);
		jQuery(".share_coll_btn").prop("disabled", true);
		jQuery(".wishlist_tab_content").removeClass("wishlist_share_active")
	})
	jQuery(document).on("change", ".rb_share_checkbox", function () {
		var checked_count = jQuery("input[name='collection_id']:checked").length;
		if (checked_count > 0) {
			jQuery(".share_coll_btn").removeAttr("disabled");
		} else {
			jQuery(".share_coll_btn").attr("disabled", "disabled");

		}
	})
	jQuery(document).on("click", ".rb_share_all_collection_btn", function () {
		if (!navigator.share) {
			alert("Sharing is not supported in this browser.");
			return;
		}

		const tokens = [];
		const names = [];


		// Collect all tokens from selected checkboxes
		jQuery(".rb_wishlist_collection_list .ct_collection_box .rb_share_checkbox:checked").each(function () {
			const token = jQuery(this)
				.closest(".ct_collection_box")
				.find(".rb_wishlist_three_dot_btn")
				.attr("data-collection-token");
			const col_name = jQuery(this).attr("data-collection-name");
			if (col_name) {
				names.push(col_name)
			}
			if (token) {
				tokens.push(token);
			}
		});

		if (tokens.length > 0) {
			var share_wishlist = {
				"shared_folder_name": JSON.stringify(names)
			}
			clevertap.event.push("wishlist item shared", share_wishlist);
			const tokenString = tokens.join("&"); // Join tokens with '&'

			navigator.share({
				title: "wishlist Share",
				url: `${window.location.origin}/pages/wishlist/${tokenString}`
			}).catch((error) => {
				console.error("Error sharing:", error);
			});
		} else {
			alert("No collections selected to share.");
		}
	});

});


function renderAddedStrip() {
  if (!productItemData || !productItemData.image) return;

  const stripHtml = `
    <div class="wish_added_head">
      <div class="wish_added_thumb_wrap">
        <div class="wish_added_thumb">
          <img src="${productItemData.image}" alt="${productItemData.name || 'Wishlist item'}" loading="lazy">
        </div>
        <span class="wish_added_tick" aria-hidden="true">
          <!-- green circle check -->
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="4" cy="4" r="4" fill="white"/>
<path d="M4 0C5.06087 0 6.07828 0.421427 6.82843 1.17157C7.57857 1.92172 8 2.93913 8 4C8 5.06087 7.57857 6.07828 6.82843 6.82843C6.07828 7.57857 5.06087 8 4 8C2.93913 8 1.92172 7.57857 1.17157 6.82843C0.421427 6.07828 0 5.06087 0 4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0ZM3.50171 4.78914L2.61314 3.9C2.58129 3.86815 2.54347 3.84288 2.50185 3.82564C2.46023 3.8084 2.41562 3.79952 2.37057 3.79952C2.32552 3.79952 2.28091 3.8084 2.23929 3.82564C2.19767 3.84288 2.15985 3.86815 2.128 3.9C2.06367 3.96433 2.02752 4.05159 2.02752 4.14257C2.02752 4.23355 2.06367 4.32081 2.128 4.38514L3.25943 5.51657C3.29119 5.54859 3.32898 5.574 3.37061 5.59134C3.41225 5.60868 3.4569 5.6176 3.502 5.6176C3.5471 5.6176 3.59175 5.60868 3.63339 5.59134C3.67502 5.574 3.71281 5.54859 3.74457 5.51657L6.08743 3.17314C6.11971 3.14142 6.14539 3.10362 6.16299 3.06192C6.18059 3.02023 6.18976 2.97546 6.18997 2.9302C6.19018 2.88494 6.18143 2.84009 6.16421 2.79823C6.147 2.75637 6.12168 2.71833 6.08969 2.68631C6.05771 2.65429 6.0197 2.62892 5.97786 2.61166C5.93602 2.5944 5.89118 2.58559 5.84592 2.58575C5.80066 2.58591 5.75588 2.59502 5.71417 2.61257C5.67245 2.63012 5.63462 2.65576 5.60286 2.688L3.50171 4.78914Z" fill="#28BE7F"/>
</svg>

        </span>
		
      </div>

      <div class="wish_added_text">Added To Wishlist</div>

	  <div class="wishlist_popup_close"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="10.9492" y="9.53516" width="2" height="12" rx="1" transform="rotate(135 10.9492 9.53516)" fill="#454545"/>
<rect x="9.53516" y="1.04883" width="2" height="12" rx="1" transform="rotate(45 9.53516 1.04883)" fill="#454545"/>
</svg>
</div>
    </div>
  `;

  // ensure only one
  $(".wishlist_popup_content .wish_added_head").remove();
  // put the strip at the very top of the white panel
  $(".wishlist_popup_content").prepend(stripHtml);
}
